import Route from '@ember/routing/route';
import { service } from '@ember/service';
// This is for types. Anything we have custom may show an error.
import type { Store as StoreService } from '@warp-drive/core';

export default class AuthenticatedAdminTuitionAssistanceApplicationsShowMessagesRoute extends Route {
  @service declare store: StoreService;

  model() {
    return this.modelFor('authenticated.admin.tuition-assistance.applications.show');
  }
}
